import Box from '@mui/material/Box';
import {alpha} from '@mui/material/styles';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';

import Label from 'src/minimal-components/label';
import FileThumbnail from 'src/minimal-components/file-thumbnail/file-thumbnail';
import {useState} from 'react';
import IsBHDialog from '@components/dialog/isBH-dialog/IsBHDialog';

// ----------------------------------------------------------------------

type Props = {
  title: {
    text: string;
    highlight: boolean;
  }[];
  path: {
    text: string;
    highlight: boolean;
  }[];
  legacyApp?: string;
  metaData?:string;
  groupLabel?: string;
  fileType?: string;
  isGroupLabelIcon?: boolean;
  isBhvalue?: boolean;
  checkisbhdata?: any;
  onClickItem?: VoidFunction;
};

export default function ResultItem({
  title,
  path,
  groupLabel,
  isGroupLabelIcon,
  fileType,
  legacyApp,
  metaData,
  isBhvalue,
  checkisbhdata,
  onClickItem
}: Props) {
  const [openIsBHDialog, setOpenIsBHDialog] = useState(false);
  const handleisBHDialog = () => {
    setOpenIsBHDialog(true);
  };
  const handleClickItem = (data: any) => {
    if (data != 'dontshow') {
      onClickItem && onClickItem();
    }
    // setOpenIsBHDialog(false);
    // onClickItem && onClickItem();
  };
  if (isBhvalue) {
    return (
      <>
        {openIsBHDialog ? (
          <IsBHDialog
            module={'clinical'}
            showDialog={true}
            setShowDialog={setOpenIsBHDialog}
            isBhvaluesearch={isBhvalue}
            isBhdata={checkisbhdata}
            triggerFunction={handleClickItem}
          />
        ) : null}
        <ListItemButton
          onClick={handleisBHDialog}
          sx={{
            borderWidth: 1,
            borderStyle: 'dashed',
            borderColor: 'transparent',
            borderBottomColor: theme => theme.palette.grey[700],
            '&:hover': {
              borderRadius: 1,
              borderColor: '#111111',
              backgroundColor: '#e7e3e3cc'
            }
          }}>
          <ListItemText
            primaryTypographyProps={{
              typography: 'subtitle2',
              sx: {textTransform: 'capitalize'}
            }}
            secondaryTypographyProps={{typography: 'caption'}}
            primary={
              <Box
                component="span"
                sx={{
                  color: '#111111'
                }}>
                {'Result Hidden'}
              </Box>
            }
            secondary={
              <Box
                component="span"
                sx={{
                  color: 'text.secondary'
                }}>
                {'Click to break the glass and view the restricted data.'}
              </Box>
            }
          />

          {/* {isBhvalue && groupLabel && <Label color="info">{groupLabel}</Label>} */}
          {/* {isGroupLabelIcon && fileType && (
            <FileThumbnail file={fileType || ''} sx={{width: 30}} />
          )} */}
        </ListItemButton>
      </>
    );
  }
  return (
    <ListItemButton
      onClick={onClickItem}
      sx={{
        borderWidth: 1,
        borderStyle: 'dashed',
        borderColor: 'transparent',
        borderBottomColor: theme => theme.palette.grey[700],
        '&:hover': {
          borderRadius: 1,
          borderColor: theme => theme.palette.primary.main,
          backgroundColor: theme =>
            alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        }
      }}>
      <ListItemText
        primaryTypographyProps={{
          typography: 'subtitle2',
          sx: {textTransform: 'capitalize'}
        }}
        secondaryTypographyProps={{typography: 'caption'}}
        primary={title.map((part, index) => (
          <Box
            key={index}
            component="span"
            sx={{
              color: part.highlight ? 'primary.main' : 'text.primary'
            }}>
            {part.text}
          </Box>
        ))}
        secondary={path.map((part, index) => (
          <Box
            key={index}
            component="span"
            sx={{
              color: part.highlight ? 'primary.main' : 'text.secondary'
            }}>
            {legacyApp && `${legacyApp} | ${metaData ?? ' '} | `}{part.text}
          </Box>
        ))}
      />

      {groupLabel && <Label color="info">{groupLabel}</Label>}
      {isGroupLabelIcon && fileType && (
        <FileThumbnail file={fileType || ''} sx={{width: 30}} />
      )}
    </ListItemButton>
  );
}
